import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=9bb9911c&scoped=true&"
import script from "./Applicants.vue?vue&type=script&lang=js&"
export * from "./Applicants.vue?vue&type=script&lang=js&"
import style0 from "./Applicants.vue?vue&type=style&index=0&id=9bb9911c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb9911c",
  null
  
)

export default component.exports